<template>
   <div>
       <el-form :inline="true" :model="formInline" label-position="left"  class="demo-form-inline"  v-if="path ==='/单词成绩查看'||path ==='/文章成绩查看'?false:true">
                  <el-form-item label="学校:">
                         <el-select v-model="formInline.schoolId" filterable placeholder="请选择" @change="changeSchoool">
                                    <el-option
                                    v-for="item in school"
                                    :label="item.name"
                                    :value="item.id">
                                    </el-option>
                        </el-select>       
                    </el-form-item>
               
                    <el-form-item label="班级:"   >
                    <el-select v-model="classid" placeholder="请选择" @change="changeClass">
                    <el-option
                      v-for="classs in sClass"
                      :label="classs.name"
                      :value="classs.id">
                    </el-option>
                    </el-select>
                    </el-form-item>
                    
                    <el-form-item label="姓名:">
                            <el-input v-model="formInline.student" placeholder="姓名"></el-input>
                    </el-form-item>
                <el-form-item label="更新时间:">
                    <el-date-picker
                        v-model="formInline.data"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="timestamp"
                        :default-time="['00:00:00', '23:59:59']"
                        >
                    </el-date-picker>
                </el-form-item>
                 <el-form-item>
                          <el-button type="primary" @click="onSubmit()" >查询</el-button>
                    </el-form-item>
            </el-form>
       <litable :colConfigs='achtablist' :listdata='studentsList' @selectShopName='sort' :page="page" :pagesize="pageInputOver">
        <el-table-column slot="opt" label="操作" width="80px">
            <template slot-scope="scope">
                <div class="buttom_c">
                        <el-button size="mini" @click="handleClick(scope.row)">查看</el-button>
                </div>
            </template>  
        </el-table-column>
           
       </litable>
<el-footer>
<div class="block">
      <p>每页条数</p>
    <el-input v-model="pageInput" @change="pageSizeChange" class="page_input" size="mini"></el-input>
  <el-pagination
      @current-change="getather"
      :current-page.sync="currentPage"
      :page-size="pageInputOver"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
</div>
    </el-footer>
   </div>
</template>
<script>
import litable from '@/components/li-table'
  import {
    mapState,
    // mapMutations,
    mapActions
  } from 'vuex'
export default {
    data () {
        return {
            path:'',
            order:'',
            classid:'',
            acPage:'',
            role:'',
            pageInputOver:20,
            pageInput:20,
            currentPage:1,
            formInline:{},
            achtablist:[]
        }
    },
    components: {
      litable  
    },
      computed: {
          ...mapState( 'students', ['studentsList','total','sClass','page','school']),
    },
    methods: {
         ...mapActions('students', ['FETCH_STUDENTS_LIST','FETCH_CLASS','FETCH_STUDENTS_SCORE','FETCH_ARCT_LIST']), 
         handleClick(row){
             if (this.path === '/单词成绩') {
                   this.$router.push({
                                    name:'单词成绩查看',
                                    query:{
                                        studentId: row.studentId
                                    }
                                }) 
             } else {
                 this.$router.push({
                     name:'文章成绩查看',
                     query:{
                         studentId: row.studentId
                     }
                 })
             }
         }, 
         changeClass(value){
             this.formInline.classId = value
         },
          changeSchoool(value){
             console.log('学校啊嗷嗷啊啊啊',value)
                let obj = {};
                obj = this.school.find((item)=>{
                    return item.id === value;
                });
                this.formInline.school = obj.name
         },
     async sort(sort){
          sessionStorage.setItem('page', this.acPage)
         if(sort.order ==="ascending"){
             this.order =sort.prop+','+ 'asc'
         } else {
             this.order =sort.prop+','+'desc'
         }
         console.log(this.order,this.acPage )
            switch (this.path) {
                case '/单词成绩':
                      await this.FETCH_STUDENTS_LIST({sort:this.order,page: this.acPage })  
                    break;
                case '/文章成绩':
                      await this.FETCH_STUDENTS_LIST({sort:this.order,page: this.acPage}) 
                    break;
            }
         },
       async  onSubmit(){
             console.log(this.formInline.data)
             if(this.formInline.data != undefined){
             this.formInline.beginTime = this.formInline.data[0]
             this.formInline.endTime = this.formInline.data[1]
             }
            sessionStorage.setItem('page', this.acPage)
           await  this.FETCH_STUDENTS_LIST(this.formInline)
            this.formInline.beginTime =''
             this.formInline.endTime = ''
               this.classid = ''
            this.formInline.classId = undefined
         },
      async  changeIndex(){
           
             switch ( this.path ) {
                 case '/单词成绩':
        this.achtablist = [{ prop: '学校', label: '学校' },
        { prop: '班级', label: '班级' },
        { prop: 'name', label: '姓名',sortable:'name' },
        { prop: 'wordStar', label: '识字星级',sortable:'wordStar'},
        { prop: 'wordAccuracy', label: '识字准确率',sortable:'wordAccuracy'},
        { prop: 'updateTime', label: '更新时间' ,sortable:'updateTime' },
        { prop: '电话', label: '电话'},
        { slot: 'opt',label: '操作' }
    ]             
                       await this.FETCH_STUDENTS_LIST(this.formInline) 
                     break;
                 case '/单词成绩查看':
                     
                     this.achtablist = [
            { prop: '关卡名称', label: '关卡名称' },
            { prop: '星级评价', label: '星级评价' },
            { prop: '准确率', label: '准确率' },
        ]
                        this.formInline.studentId = this.$route.query.studentId
                        await this.FETCH_STUDENTS_SCORE(this.formInline)
                     break
                 case '/文章成绩':
                     
                    this.achtablist = [{ prop: '学校', label: '学校' },
                                                { prop: '班级', label: '班级' },
                                                { prop: 'name', label: '姓名' ,sortable:'name'},
                                                { prop: 'articleStar', label: '阅读星级' ,sortable:'articleStar' },
                                                { prop: 'updateTime', label: '更新时间' ,sortable:'updateTime' },
                                                 { prop: '电话', label: '电话'},
                                                { slot: 'opt',label: '操作' }
                                            ]
                       await this.FETCH_STUDENTS_LIST(this.formInline) 
                     break;
                case '/文章成绩查看':
                    this.achtablist = [{ prop: '星级', label: '星级' },
                    { prop: '文章', label: '文章' },
                    { prop: '星级评价', label: '星级评价' },
                    { prop: '答题情况', label: '答题情况' },]
                    this.formInline.studentId = this.$route.query.studentId
                    await this.FETCH_ARCT_LIST(this.formInline)
                break
             }
            
         },
        pageSizeChange(value){
        console.log(value)
        this.pageInputOver = value
        this.formInline.pageSize = value
        this.changeIndex()
    },
        getather(val){
        this.acPage = val
        this.formInline.page = val
        sessionStorage.setItem('page',val)
        console.log(this.formInline)
        console.log(this.order)
        if (this.order === '') {
                    this.changeIndex()
        } else {
            this.formInline.sort = this.order
            this.changeIndex()
        }
      
            }
    },
    async created () {
         this.path = this.$route.path
          this.role =JSON.parse( sessionStorage.getItem('role')).role
          console.log(this.role)
        await this.changeIndex()
         this.find.pageSize = this.pageInput
        if (this.role === 'teacher') {
              this.FETCH_CLASS( this.studentsList[0].schoolId)      
        }
      
       
    }
}
</script>
<style lang="scss" scoped>
.block{
    margin-top: 5px;
    float:right;
    display: flex;
    justify-content: center;
    align-items: center;
    .page_input{
        width: 50px;
        font-size: 14px;
       
        .el-input__inner{
            height: 30px;
        }
     
    }
}
</style>
